module.exports = {
	"header": "50+ brands to start collaboration with Spotin",
	"date": "2020/11/02",
	"imgSrc": "5.jpg",
	"imgAlt": "50+ brands to start collaboration with Spotin",
	"ingress": "By: it-Retail (in Swedish)",
	"externalLink": "https://it-retail.se/adnym-gotrich-residus-och-whyred-och-ett-50-tal-varumarken-inleder-samarbete-med-spotin-for-ny-form-av-e-handel/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/5/article.json
// module id = 95
// module chunks = 0